<template>
	<v-dialog
		v-model="dialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-plus</v-icon>
				写真追加
			</v-btn>
		</template>

		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title clxass="color-white">写真追加</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pa-2">
				<DragUpload ref="upload" @fileShare="fileShare" :attached_files="files" />
			</v-sheet>
			<v-row no-gutters justify="end">
				<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import DragUpload from "../../shared/DragUpload.vue"

export default {
	props: {
		id: {
			type: Number,
			required: true,
		},
	},
	components: {
		DragUpload,
	},
	data() {
		return {
			common,
			dialog: false,
			files: [],
		}
	},
	methods: {
		closeDialog() {
			this.dialog = false
			this.$refs.upload.resetFiles()
		},
		fileShare(files) {
			this.files = files
			this.uploadPhotos(this.files[0])
		},
		uploadPhotos(file) {
			let headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()
			formData.append("file", file)
			const url = `/erp/v1/order_individual_infos/${this.id}/photos`

			axios
				.post(url, formData, { headers })
				.then((res) => {
					this.$emit("create-photo", { data: res.data, order_individual_info_id: this.id })
					this.files.splice(0, 1)
					if (this.files.length) {
						this.uploadPhotos(this.files[0])
					} else {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: "写真を追加しました。",
						})
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
